import { IS_BROWSER } from '~/app/constants'

export const initScrollRestoration = (): void => {
  if (IS_BROWSER && 'scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'
  }
}
